import React, { Component } from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import styled from 'styled-components';

/* ---------- styled ---------- */
const TimelineList = styled.ul`
    padding-left: 20px;
    margin: 10px 0;
`;
const ChildLinks = styled.ul`
    margin: 6px 0 12px 16px;
    padding-left: 16px;
    list-style: disc;
    a { color: #2c7be5; text-decoration: underline; }
    a:hover { text-decoration: none; }
`;
const ContentContainer = styled.div`
    padding: 20px !important;
`;
const StyledTimeline = styled(VerticalTimeline)`
    .vertical-timeline-element-content {
        box-shadow: 0 3px 10px rgba(0,0,0,0.1);
        border-radius: 8px;
    }
    .vertical-timeline-element-date {
        color: #333;
        font-weight: 600;
    }
`;

/* ---------- JSDoc typedefs so TS doesn't infer unknown ---------- */
/** @typedef {{date: string, agenda?: string, ppt?: string}} Meeting */
/** @typedef {{site: string, start: string}} Enrollment */

/* ---------- data ---------- */
const SIGHT1_GRANT = { start: '2019-09-30', end: '2024-09-29' };

/** @type {Meeting[]} */
const SIGHT1_CAB = [
  // 2019
  { date: '2019-09-20', ppt: 'https://docs.google.com/presentation/d/1VLFJP21KkjUf39ZbUnu5-G-uIr1Bw4_Y/edit?usp=sharing&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2019-11-21', ppt: 'https://docs.google.com/presentation/d/1gCJPUcswSUSOQEzyZ4QC6pe0-uLvoMSk/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  // 2020
  { date: '2020-01-30', agenda: 'https://docs.google.com/document/d/1A1llblqvIn775UqnzWZ52FFFd3NqF703/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1-ozdhWOvSPEU1qfjxot5iRb4V3JaR9fi/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2020-05-15', agenda: 'https://docs.google.com/document/d/10s_qa1-4DJ4FkqhCND2SCl9C6SQS-aaq/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/19TfBr6_Xc5L7IaJIiIIXLKd31iNSqC7p/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2020-09-10', agenda: 'https://docs.google.com/document/d/1_AetaPKxqOKlz3NlWfc3ZoCKEiMBR-Eh/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1yt6NUgZwOTKJhAOPquos_9vTMdvHQAOY/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2020-11-19', agenda: 'https://docs.google.com/document/d/1c_Mdb5x5O9Fjn5Th23LssqpQtNSv4FzO/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1WKDVz3f0p8nB7vd6W2i-fg48-3RVKE_-/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  // 2021
  { date: '2021-02-18', agenda: 'https://docs.google.com/document/d/1gUVkTjaO7hD3C9Hdifp9aJfwqSzcTmEJ/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1hQJw1HKTorjiRjLAaLJ8jVOMoYNZTyqQ/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2021-05-27', agenda: 'https://docs.google.com/document/d/1LpFJ4WmZ3HXnE5SnO6bcY-X-V4vyix5Z/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true'},
  { date: '2021-12-02', agenda: 'https://docs.google.com/document/d/19Vp6eCtOo-JNeJR-yW9KAp8wdPtDjFEz/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1XB6mNURjlyzGOS773-NrS0TaWIWrssDc/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  // 2022
  { date: '2022-03-17', ppt: 'https://docs.google.com/presentation/d/1phbEubGjFolYUZQFVoyqo_UmNVGHhEqP/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2022-05-19', agenda: 'https://docs.google.com/document/d/1Gm26U4f1740YRJP7sgVW7bk-5nZnXCbS/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1VKLuT-Hl3ztZWSzkuKTSdn-pUxvuS2rW/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2022-09-15', agenda: 'https://docs.google.com/document/d/1SeC5S8lN12vB4UU4IlUMBdKPvnv1gycC/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1N7Aj1gqElrOaxaukbY5dMNCwpSj_iMXb/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2022-12-08', agenda: 'https://docs.google.com/document/d/1Zx1wwKJldxD_gCwey4kf2zSoxfvb0PAA/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1u0DPLxiNPNHlbjR83r8aqTumkivvRr66/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  // 2023
  { date: '2023-03-16', ppt: 'https://docs.google.com/presentation/d/1phbEubGjFolYUZQFVoyqo_UmNVGHhEqP/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2023-06-12', agenda: 'https://docs.google.com/document/d/1ElWk_hn0J-Cp-u9P_Tw-6uiTlfsCLgpj/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1J8VQls2TBhvkkWEimADT_NKtlSEHOaF5/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2023-09-22', agenda: 'https://docs.google.com/document/d/1vNfAZePEXDfIbOUzTNR01mX7RtNaY3j5/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1MuXFx2UjxaQyBjdRkhabK5bWRmg5Et12/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2023-12-07', agenda: 'https://docs.google.com/document/d/1urnJWCSPV53io0cjOqaQOx-Yg4qSb_qp/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1mlRkUIR0Oi4zAMLeg57a7HOxzWu2m2EG/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  // 2024
  { date: '2024-03-14', agenda: 'https://docs.google.com/document/d/15-7e6z5X8V24gMFTu_4g8vILqElps1yp/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1lUJptuk7TxM3qRbZwPTmlTFugMNZ68r9/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2024-06-20', agenda: 'https://docs.google.com/document/d/19AvuXGTWR04us22fpSQveBy-JZ2UU4UV/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1XF4UddREp-wKFbgmDcOGzifn__eRUlSq/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2024-09-19', agenda: 'https://docs.google.com/document/d/1j5TgUENnowN8kbA1XUM6TIhI5LXFkuZp/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/10JOzvEJ171gHbEDUyc1UZUfiYQG6kJ2x/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
];

/** @type {Enrollment[]} */
const SIGHT1_ENROLL = [
  { site: 'Hope', start: '2020-07-28' },
  { site: 'Hamilton', start: '2021-07-27' },
];
const SIGHT1_ENROLL_END = '2024-01-27';

const SIGHT2_GRANT = { start: '2024-09-30', end: '2029-09-29' };
/** @type {Meeting[]} */
const SIGHT2_CAB_2025 = [
  { date: '2025-01-17', agenda: 'https://docs.google.com/document/d/1Reegc9bz0a7cRA7mtNkNrpNzLBcOeT6A/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1128NVoSjV5nq8u7hQbNubTgMPjps1WSr/edit?usp=sharing&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2025-02-21', agenda: 'https://docs.google.com/document/d/1IDRz8bNkddqXuQMyQVcEZ2WADFUfyStK/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/12asW7TGKj4SMiKcgW2t-4sfKHwqg8Pw2/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2025-03-07', agenda: 'https://docs.google.com/document/d/1BDguOfVl5Y_UP0vhDGLqNch6FB--IOLi/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/137iWqORRZEMBdRIDm0HuvzAiqRzo34Ak/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2025-04-04', agenda: 'https://docs.google.com/document/d/1K0nFyXDUOW7_Vc_HF2qizdRpkL6d9bRz/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1AU8qCXhDpEYVrox9pd7YcgjNwersfznz/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2025-05-30', agenda: 'https://docs.google.com/document/d/13SoR6HXmyftGevwmUVd3nG6jVWawvW71/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1nTPdH0YMSq2d5_hmOY6zMnGLnMNRmlar/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2025-09-05', agenda: 'https://docs.google.com/document/d/1ffZbjEX-uKRbB4zWHOLqYCSXA52K9PLU/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/19zxnOYikZ4zV1WBpiQN9TCN03iJ9xydU/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2025-11-21', agenda: 'https://docs.google.com/document/d/1Bmm8BbeI-3OKRSqhdrBTITQUsPJuQ4e1/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1LGfpVxCrvG_ocPgzk9gpJLU161-qVD2c/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2025-12-19', agenda: 'https://docs.google.com/document/d/1Qwav58klkezofS1GIC5zB7Xktu-CDcMg/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1U_J0nkxePvlTGczDGQBobOP7pxFglcIN/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
];

const SIGHT2_CAB_2026 = [
  { date: '2026-01-16', agenda: 'https://docs.google.com/document/d/1BcXEJeHIZEjOmpOzw_19ixllySZ_BXNp/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/108CcetPWLq6gXvowUcZZlpDRLqJZI9sg/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
  { date: '2026-04-17', agenda: 'https://docs.google.com/document/d/1H5zsu5I4uYnSWesVx3nugVTmVqmWpLSz/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true', ppt: 'https://docs.google.com/presentation/d/1Iyzm7RLjA6ASRCueUeaTorhJZjdMB6Mg/edit?usp=drive_link&ouid=103717241932606280070&rtpof=true&sd=true' },
];

/* ---------- helpers ---------- */
function fmt(iso) {
  return new Date(iso + 'T00:00:00Z').toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC',
  });
}
function yearOf(iso) { return iso.slice(0, 4); }
function groupByYear(items) {
  return items.reduce(function (acc, item) {
    const y = yearOf(item.date);
    (acc[y] || (acc[y] = [])).push(item);
    return acc;
  }, {});
}

/** @returns {import('react').ReactElement[]} */
function renderEnrollItems(list) {
  return list.map(function (e) {
    return (
      <li key={e.site}>
        <strong>Start {e.site}:</strong> {fmt(e.start)}
      </li>
    );
  });
}

/** @param {Meeting[]} meetings @returns {import('react').ReactElement[]} */
function renderMeetingsWithLinks(meetings) {
  return meetings.map(function (m) {
    return (
      <li key={m.date} style={{ marginBottom: '4px' }}>
        <strong>{fmt(m.date)}</strong>
        <ChildLinks>
          {m.agenda && <li><a href={m.agenda || '#'} target="_blank" rel="noopener noreferrer">Agenda</a></li>}
          {m.ppt && <li><a href={m.ppt || '#'} target="_blank" rel="noopener noreferrer">Power Point Presentation</a></li>}
        </ChildLinks>
      </li>
    );
  });
}

/* ---------- class component ---------- */
class SightTimeline extends Component {
  render() {
    const sight1ByYear = groupByYear(SIGHT1_CAB);

    return (
      <StyledTimeline>
        {/* SIGHT 1: Grant window */}
        <VerticalTimelineElement
          date={fmt(SIGHT1_GRANT.start) + ' \u2192 ' + fmt(SIGHT1_GRANT.end)}
          iconStyle={{ background: 'rgb(100, 100, 100)', color: '#fff' }}
        >
          <ContentContainer>
            <h3 className="vertical-timeline-element-title">SIGHT 1 Grant</h3>
            <p>Grant period covering Community Advisory Board (CAB) meetings and enrollment.</p>
          </ContentContainer>
        </VerticalTimelineElement>

        {/* SIGHT 1: CAB meetings, grouped by year */}
        {Object.keys(sight1ByYear).sort().map(function (y) {
          return (
            <VerticalTimelineElement
              key={'s1-' + y}
              date={y}
              iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
            >
              <ContentContainer>
                <h3 className="vertical-timeline-element-title">Community Advisory Board Meetings</h3>
                <TimelineList>{renderMeetingsWithLinks(sight1ByYear[y])}</TimelineList>
              </ContentContainer>
            </VerticalTimelineElement>
          );
        })}

        {/* SIGHT 1: Enrollment */}
        <VerticalTimelineElement
          date="2020 – 2024"
          iconStyle={{ background: 'rgb(255, 193, 7)', color: '#fff' }}
        >
          <ContentContainer>
            <h3 className="vertical-timeline-element-title">SIGHT 1 Enrollment</h3>
            <TimelineList>
              {renderEnrollItems(SIGHT1_ENROLL)}
              <li><strong>Both End Date:</strong> {fmt(SIGHT1_ENROLL_END)}</li>
            </TimelineList>
          </ContentContainer>
        </VerticalTimelineElement>

        {/* SIGHT 2: Grant window */}
        <VerticalTimelineElement
          date={fmt(SIGHT2_GRANT.start) + ' \u2192 ' + fmt(SIGHT2_GRANT.end)}
          iconStyle={{ background: 'rgb(156, 39, 176)', color: '#fff' }}
        >
          <ContentContainer>
            <h3 className="vertical-timeline-element-title">SIGHT 2 Grant</h3>
          </ContentContainer>
        </VerticalTimelineElement>

        {/* SIGHT 2: 2025 CAB meetings */}
        <VerticalTimelineElement
          date="2025"
          iconStyle={{ background: 'rgb(76, 175, 80)', color: '#fff' }}
        >
          <ContentContainer>
            <h3 className="vertical-timeline-element-title">Community Advisory Board Meetings</h3>
            <TimelineList>{renderMeetingsWithLinks(SIGHT2_CAB_2025)}</TimelineList>
          </ContentContainer>
        </VerticalTimelineElement>

        {/* SIGHT 2: 2026 CAB meetings */}
        <VerticalTimelineElement
          date="2026"
          iconStyle={{ background: 'rgb(76, 175, 80)', color: '#fff' }}
        >
          <ContentContainer>
            <h3 className="vertical-timeline-element-title">Community Advisory Board Meetings</h3>
            <TimelineList>{renderMeetingsWithLinks(SIGHT2_CAB_2026)}</TimelineList>
          </ContentContainer>
        </VerticalTimelineElement>

        {/* end marker */}
        <VerticalTimelineElement
          iconStyle={{ background: 'rgb(33, 33, 33)', color: '#fff' }}
          icon={<span />}
        />
      </StyledTimeline>
    );
  }
}

export default SightTimeline;
export { SightTimeline };



// WEBPACK FOOTER //
// ./src/pages/SightTimeline/index.js